import { render, staticRenderFns } from "./ModalNewPassword.vue?vue&type=template&id=67d56e70&"
import script from "./ModalNewPassword.vue?vue&type=script&lang=js&"
export * from "./ModalNewPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67d56e70')) {
      api.createRecord('67d56e70', component.options)
    } else {
      api.reload('67d56e70', component.options)
    }
    module.hot.accept("./ModalNewPassword.vue?vue&type=template&id=67d56e70&", function () {
      api.rerender('67d56e70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Login/Modal/ModalNewPassword.vue"
export default component.exports